import { useEffect, useState } from 'react'

export function useIsMobile() {
  const [isMobile, set] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(pointer: coarse), (max-width: 900px)')
    const handleChange = () => set(mq.matches)

    handleChange()
    mq.addEventListener?.('change', handleChange)

    return () => mq.removeEventListener?.('change', handleChange)
  }, [])

  return isMobile
}

export function getMobileDPRCap() {
  const w = Math.min(window.innerWidth, window.innerHeight)
  if (w < 380) return 1.5
  return 2
}
